import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '@fluentui/react-components';
import { Sparkle20Filled, Sparkle20Regular } from '@fluentui/react-icons';
import { useSaveMomentPreferences, useUserPreferences } from '../../services/complianceApi';
import { momentSettings } from './moments';

// The per-person OFF SWITCH (spec rule 5). It lives in the header beside the theme and language
// toggles — the app's other per-person settings — because statetax has no settings page. Saving
// sends ONLY the moments field; the server merges, so the Tasks page's saved filters are untouched.

export default function MomentsToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { data: prefs, isSuccess } = useUserPreferences();
  const { mutate: save, isPending } = useSaveMomentPreferences();
  const settings = momentSettings(prefs);
  const label = settings.enabled ? t('moments.toggle.turnOff') : t('moments.toggle.turnOn');

  return (
    <Tooltip content={label} relationship="label">
      <Button
        appearance="subtle"
        shape="circular"
        className={className}
        aria-pressed={settings.enabled}
        disabled={!isSuccess || isPending}
        icon={settings.enabled ? <Sparkle20Filled /> : <Sparkle20Regular />}
        onClick={() => save({ enabled: !settings.enabled, seen: settings.seen })}
      />
    </Tooltip>
  );
}
